var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},_vm._l((_vm.sections),function(section,x){return _c(_vm.resolveComponent(section.acf_fc_layout),_vm._b({key:x,tag:"component"},'component',section,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }